/**
 * @fileoverview POST handler for the "/api/calculated_filters/:id/:app_group_id/refresh" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedFiltersIdAppGroupIdRefreshCacheKeys } from "./constants";
import type {
  PostApiCalculatedFiltersIdAppGroupIdRefreshProps,
  PostApiCalculatedFiltersIdAppGroupIdRefreshResult,
} from "./types";

export const postApiCalculatedFiltersIdAppGroupIdRefresh = reactQueryMutationAdapter(
  postApiCalculatedFiltersIdAppGroupIdRefreshCacheKeys,
  (
    props: PostApiCalculatedFiltersIdAppGroupIdRefreshProps
  ): Promise<PostApiCalculatedFiltersIdAppGroupIdRefreshResult> => {
    const { id, app_group_id: appGroupId } = props;
    return fetch(`/api/calculated_filters/${id}/${appGroupId}/refresh`, "POST", undefined, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
